import { createSelector } from "reselect";

import { OtherAnnotationCategory } from "@busbud/int-schemas/udm";

import { getTripsAnnotations } from "./state-accessors";

export const GetOperatorAwardsAnnotations = createSelector(
  [getTripsAnnotations],
  annotations =>
    Object.keys(annotations).filter(
      // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      id => annotations[id].category === OtherAnnotationCategory.OperatorRelated
    )
);
